import * as Yup from "yup";
import { REGEX } from "../../../utils/constants";
/**
 * @description declaration form schema for client validations
 */
export const signUpSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email address field  is required"),
  password: Yup.string()
    .matches(/^\S*$/, 'Space is not allowed')
    .min(8, "Password must be atleast 8 characters long")
    .max(50, "Maximum 50 symbols")
    .required("Password field is required")
    .matches(REGEX.PASSWORD,
      'Password must contain atleast one alphabet, one special character and one numeric value'),
  confirmPassword: Yup.string()
    .required("Confirm password field is required")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
  fname: Yup.string().trim()
    .required("This field is required")
    .max(50, "This field should be maximumun 50 characters.")
    .matches(REGEX.NAME,
      'This field only accepts alphabets!'),
  orgName: Yup.string().trim()
    .required("This field is required")
    .max(100, "This field should be maximumun 100 characters."),
  acceptTerms: Yup.bool().oneOf([true], 'Please accept the terms and condition')
});

/**
 * @description params intilaization 
 */

export const signUpInit = {
  email: '',
  password: '',
  fname: '',
  lname: '',
  confirmPassword: '',
  orgName: '',
  acceptTerms: false
}